module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "readouts"
  }, [_c('p', {
    staticClass: "speed"
  }, [_vm._v("\n    " + _vm._s(_vm.unit === 'mi' ?
    Math.round(_vm.readout.speed * 0.621371) || 0 :
    _vm.readout.speed) + "\n    "), _c('small', [_vm._v(_vm._s(_vm.units[_vm.unit].speed))])]), _vm._v(" "), _c('p', {
    staticClass: "elevation"
  }, [_vm._v("\n    " + _vm._s(_vm.unit === 'mi' ?
    Math.round(_vm.readout.elevation * 3.2808399) || 0 :
    _vm.readout.elevation) + "\n    "), _c('small', [_vm._v(_vm._s(_vm.units[_vm.unit].elevation) + " ")])]), _vm._v(" "), _c('p', {
    staticClass: "distance"
  }, [_vm._v("\n    " + _vm._s(_vm.readout.distance &&
    (
      (_vm.readout.distance / 1000) *
      (_vm.unit === 'mi' ? 0.621371 : 1)
    ).toLocaleString(undefined, {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    })) + "\n    " + _vm._s(_vm.units[_vm.unit].distance) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6256caaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Readouts.vue
// module id = 202
// module chunks = 1